var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowercase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "currentColor",
    viewBox: "0 0 17 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.306.95a.6.6 0 0 1 .6.6v5.87c.636-.665 1.478-1.07 2.4-1.07 1.988 0 3.6 1.88 3.6 4.2 0 2.32-1.612 4.2-3.6 4.2-.922 0-1.764-.404-2.4-1.069v.47a.6.6 0 0 1-1.2 0V1.55a.6.6 0 0 1 .6-.6Zm3 12.6c1.159 0 2.4-1.164 2.4-3s-1.241-3-2.4-3c-1.16 0-2.4 1.164-2.4 3s1.24 3 2.4 3ZM3.579 7.175c-.584.022-1.096.158-1.404.312a.6.6 0 1 1-.537-1.073c.492-.246 1.179-.41 1.895-.438.72-.028 1.526.08 2.242.438 1.536.768 1.53 2.29 1.53 2.892v4.844a.6.6 0 0 1-1.2 0v-.494c-1.095.799-2.411 1.313-3.754.955-2.26-.605-3.04-3.652-.779-5.16.858-.571 1.901-.73 2.85-.682.588.03 1.165.14 1.68.3-.018-.576-.134-1.216-.864-1.582-.486-.243-1.08-.334-1.66-.312Zm2.527 3.165a5.663 5.663 0 0 0-1.745-.372c-.792-.04-1.55.101-2.124.481-1.338.893-.916 2.645.424 3.003 1.082.288 2.325-.298 3.445-1.356V10.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowercase);
export default __webpack_public_path__ + "static/media/lowercase.54c932566d34f8b8740ce2b428170e83.svg";
export { ForwardRef as ReactComponent };